<!--  -->
<template>
  <div>
    <NavBar />
    <div class="content-container">
      <div class="list-container">
        <el-row>
          <el-col :span="6" class="left-info">
            <div class="user-info">
              <img src="@/assets/user_images/默认头像@1x.png" class="user-img">
              <div class="user-email">{{ userInfo.email }}</div>
              <div class="user-phone">{{ phoneNunTrans(userInfo.telephone) }}</div>
              <el-button plain @click="handlePassword">修改密码</el-button>
            </div>
            <div class="tab-list">
              <div :class="active == '0' ? 'tab-item active-item' : 'tab-item'" @click="handleClick(0, '基本资料')">
                <div class="icon"></div>
                <div class="tab-name">基本资料</div>
              </div>
              <div :class="active == '1' ? 'tab-item active-item' : 'tab-item'" @click="handleClick(1, '主体信息')">
                <div class="icon"></div>
                <div class="tab-name">主体信息</div>
              </div>
              <div :class="active == '2' ? 'tab-item active-item' : 'tab-item'" @click="handleClick(2, '收件信息')">
                <div class="icon"></div>
                <div class="tab-name">收件信息</div>
              </div>
            </div>
          </el-col>
          <el-col :span="18" class="right-info">
            <div class="basc-info">
              <div v-if="active == '0'" class="label-title">基本资料</div>
              <div :class="active == '0' ? 'info-content' : ''">
                <BascInfo v-if="active == '0'" ref="bascInfo" />
                <BodyInfo v-if="active == '1'" />
                <AddressInfo v-if="active == '2'" />
                <ChagePassWord v-if="active == '3'" />
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/navBar"
import BascInfo from "./components/bascInfo.vue"
import BodyInfo from "./components/bodyInfo.vue"
import AddressInfo from "./components/addressInfo.vue"
import { getAllInfo } from "@/api/siter"
export default {
  components: { NavBar, BascInfo, BodyInfo, AddressInfo },
  data() {
    return {
      id: null,
      active: 0,
      currentTitle: "基本资料",
      autoHeight: 800,
      userInfo: {
        telephone: ""
      },
      provinceList: [],
      cityList: []
    };
  },
  mounted() {
    const _this = this
    window.onresize = function () {
      _this.autoHeight = document.body.clientHeight - 400
    }
    this.getAllSiterInfo()
  },
  methods: {
    //获取文档高度
    // getBodyHeight
    //获取流量主所有信息
    getAllSiterInfo() {
      getAllInfo({ trafficId: this.id }).then(res => {
        if (res.code == '0') {
          if (res.data.trafficUserNewVO) {
            this.userInfo = res.data.trafficUserNewVO
            // this.$refs.bascInfo.initData(this.userInfo)
          }
        }
      })
    },
    //修改密码点击
    handlePassword() {
      this.$router.push("/changePassWord")
    },
    //主体切换
    handleClick(_val, _title) {
      this.active = _val
      this.currentTitle = _title
    },
    //电话好吗转换
    phoneNunTrans(phone) {
      var _result = "--"
      if (phone) {
        if (phone.length > 7) {
          _result = phone.replace(/^(\d{3})\d{4}(\d+)/, "$1****$2") || "--";
        } else {
          _result = phone.replace(/^(\d{2})\d{2}(\d+)/, "$1***$2") || "--";
        }

      }
      return _result
    }
  }
}

</script>
<style lang='scss' scoped>
.list-container {
  margin-top: 24px;

  .left-info {
    .user-info {
      width: 282px;
      height: 282px;
      background: #ffffff;
      border-radius: 10px;
      text-align: center;

      .user-img {
        margin-top: 40px;
        height: 80px;
        width: 80px;
      }

      .user-email {
        margin-top: 16px;
        color: #000000;
        font-size: 16px;
        line-height: 22px;
      }

      .user-phone {
        margin-top: 4px;
        font-size: 14px;
        line-height: 20px;
        color: rgba($color: #000000, $alpha: 0.45);
      }

      .el-button {
        margin-top: 32px;
        border-color: #05A7EA;
        color: #05A7EA;
      }
    }

    .tab-list {
      margin-top: 16px;
      width: 282px;
      height: 156px;
      background: #ffffff;
      border-radius: 10px;
      overflow: hidden;

      .tab-item {
        overflow: hidden;
        height: 52px;
        line-height: 52px;
        font-size: 14px;
        color: #000000;
        background: #ffffff;
        text-indent: 32px;
        cursor: pointer;

        &:hover {
          background: rgba(19, 194, 194, 0.05);
        }

        .icon {
          float: left;
          width: 4px;
          height: 24px;
          background: #ffffff;
          margin-top: 14px;
        }
      }

      .active-item {
        font-weight: 500;

        .icon {
          background: #05A7EA;
        }
      }
    }
  }

  /deep/.el-card {
    border: none;
    box-shadow: none;
  }

  .right-info {
    .basc-info {
      background: #ffffff;
      border-radius: 10px;
      height: 90vh;

      .label-title {
        text-indent: 32px;
        height: 72px;
        line-height: 72px;
        font-size: 16px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        border-bottom: 1px solid rgba($color: #000000, $alpha: 0.05);
      }

      .info-content {
        padding: 24px 40px;
      }
    }
  }
}
</style>